import { EyeOutlined } from '@ant-design/icons'
import { Button, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useNavigate } from 'react-router-dom'

import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

export const LaboratoryClassifiersPage = () => {
  const { t } = useLocales()
  const navigate = useNavigate()

  const dataSource = [
    {
      key: 'investigation-types',
      title: t('laboratory_classifiers.investigation_type')
    },
    {
      key: 'value-options',
      title: t('laboratory_classifiers.value_options')
    },
    {
      key: 'reference-intervals',
      title: t('laboratory_classifiers.reference_intervals')
    }
  ]

  const columns: ColumnsType = [
    {
      key: 'title',
      dataIndex: 'title',
      title: t('medicine_register.products.name')
    },
    {
      key: 'action',
      width: 80,
      render: ({ key }) => (
        <Button icon={<EyeOutlined />} onClick={() => navigate(key)}>
          {t('common.details')}
        </Button>
      )
    }
  ]

  return (
    <PageBreadcrumbs
      title={t('menu.laboratory_classifiers')}
      items={[
        {
          title: t('menu.laboratory_classifiers')
        }
      ]}
    >
      <Table
        rowKey="title"
        rowClassName="pointer"
        bordered
        onRow={({ key }) => ({
          onClick: () => navigate(key)
        })}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </PageBreadcrumbs>
  )
}
